// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/EventCalendar/calendar.css
// module id = 2100
// module chunks = 0